module.exports = __webpack_public_path__ + "muli-bold-webfont.24fa3cc860a6bfe1c403.woff";


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/koraal-mijnmening-backoffice/checkout/src/assets/fonts/muli/muli-bold-webfont.woff
// module id = ../../../../../src/assets/fonts/muli/muli-bold-webfont.woff
// module chunks = styles